import React, { useEffect, useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import type { XYCoord } from "react-dnd";
import { AiUsageType, CookieHelper } from "./aiservice/aiClientStorage";

import AiMenu from "./aiservice/aiMenu";
import Conversation from "./aiservice/conversation";
import QuestionField from "./aiservice/questionfield";
import { useChat } from "./aiservice/aiContext";
import { createPortal } from "react-dom";
import { getUrlParameter, removeUrlParameter } from "./aiservice/aiservice";
import * as $ from "jquery";

export const aiServiceBaseUrl = "/api/ai/1.0";

export interface DragItem {
  type: string;
  id: string;
  top: number;
  left: number;
}

const defaultPosition = {
  left: -70,
  top: 100,
};

export default function AiComponent() {
  const hasMounted = useRef(false);
// context
  const {
    currentConversation,
    aiModalState,
    setAiModalState,
    aiContent,
    setQuestionValue,
    handleSend,
    startNewChat,
  } = useChat();
  const storedAiUsage = CookieHelper.readAiUsage();
const isToday = (date: Date) => {
    const today = new Date();
    return date.getTime() > today.getTime() - 86400000;
  };
  const setStartupVisibility = () => {
    if(currentConversation &&
      currentConversation.Posts &&
      currentConversation.Posts.length > 0 && !isToday(new Date(
            currentConversation!.Posts[
              currentConversation!.Posts.length - 1
            ].CreatedDate
          ))){
            return false;
          }
          else{
            return storedAiUsage?.modalOpen ?? false
          }
  };
  const [aiModalVisibility, setAiModalVisibility] = React.useState<boolean>(
    storedAiUsage?.modalOpen ?? false
  );
  const [canDrag, setCanDrag] = React.useState<boolean>(false);
  const [headerQuery, setHeaderQuery] = React.useState<string>("");
  const [position, setPosition] = React.useState<{ x: number; y: number }>({
    x: storedAiUsage?.left ?? defaultPosition.left,
    y: storedAiUsage?.top ?? defaultPosition.top,
  });

  

  useEffect(() => {
    const chatContainer = document
      .querySelector(".ai-modal__presentation-content")
      ?.querySelector(".presentation-main");
    if (!chatContainer) return;

    // Create a MutationObserver to observe changes in the chat container
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === "childList") {
          const lastPost = chatContainer.lastElementChild;
          if (lastPost) {
            lastPost.scrollIntoView({ behavior: "smooth" });
          }
        }
      }
    });
   

    // Start observing the chat container for added nodes (new posts)
    observer.observe(chatContainer, { childList: true });

    // Cleanup observer on component unmount
    return () => observer.disconnect();
  }, [currentConversation]);

  // get url param
  useEffect(() => {
    if (!!headerQuery) {
      startNewChat();
    }
  }, [headerQuery]);

  useEffect(() => {
    if (
      currentConversation &&
      currentConversation.Posts &&
      currentConversation.Posts.length > 0
    ) {
      if (
        !isToday(
          new Date(
            currentConversation!.Posts[
              currentConversation!.Posts.length - 1
            ].CreatedDate
          )
        )
      ) {
        startNewChat();
      }
    }
  }, [aiModalVisibility]);

  useEffect(() => {
    let lastWidth = window.innerWidth;
    let lastHeight = window.innerHeight;

    // Reset the position of the box if resized more than 10px
    window.addEventListener("resize", () => {
      const newWidth = window.innerWidth;
      const newHeight = window.innerHeight;

      const widthDiff = Math.abs(newWidth - lastWidth);
      const heightDiff = Math.abs(newHeight - lastHeight);

      if (widthDiff > 10 || heightDiff > 10) {
        setPosition({ x: defaultPosition.left, y: defaultPosition.top });
      }

      lastWidth = newWidth;
      lastHeight = newHeight;
    });

    // Define the function to handle keydown events
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        //setAiModalVisibility(false);
      }
    };

    // Attach the event listener to the document
    document.addEventListener("keydown", handleKeyDown);

    const initialQuery = getUrlParameter("aiquery");
    if (initialQuery) {
      handleSend(initialQuery);
      setAiModalVisibility(true);
      removeUrlParameter("aiquery");
    }

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const updateAiClientStorage = () => {
    const clientAiData = {
      left: position.x,
      top: position.y,
      modalState: aiModalState,
      modalOpen: aiModalVisibility,
      currentConversationId: currentConversation?.Id,
    } as AiUsageType;

    CookieHelper.createOrUpdateAiUsage(clientAiData, 30);
  };

  

  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: "aimodal",
      item: { id: "aibox", left: position.x, top: position.y },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    ["aibox", position.x, position.y]
  );

  useEffect(() => {
    const chatFrame = $("#chat-iframe");
    aiModalVisibility ? chatFrame.hide() : chatFrame.show();

    if (aiModalVisibility && window.innerWidth < 960) {
      setAiModalState("full");
    }
  }, [aiModalVisibility]);

  useEffect(() => {
    console.log(aiModalState, aiModalVisibility);
    if (aiModalVisibility) {
      if (aiModalState === "full") {
        $("html").addClass("lock-scroll");
      } else {
        $("html").removeClass("lock-scroll");
      }
    }
  }, [aiModalState, currentConversation]);

  useEffect(() => {
    if (hasMounted.current) {
      updateAiClientStorage();
    } else {
      if (
        position.y > window.innerHeight ||
        position.x < 0 - window.innerWidth
      ) {
        setPosition({ x: defaultPosition.left, y: defaultPosition.top });
      }

      hasMounted.current = true;
    }
  }, [position, aiModalState, currentConversation, aiModalVisibility]);

  function mainCTA(e: React.MouseEvent) {
      e.preventDefault();
    if (window.innerWidth < 1200) {
      setAiModalState("full");
    } else {
      setAiModalState("small");
    }
    if (!aiModalVisibility) {
      setAiModalVisibility(true);
    }

    setTimeout(() => {
                ($("#aibox [tabindex]:visible")[0] as HTMLLinkElement).focus();

    }, 1)

    const headerSearchQuery = $("#searchfield")?.val();

    if (!!headerSearchQuery) {
      if (
        headerQuery !== headerSearchQuery &&
        typeof headerSearchQuery === "string"
      ) {
        setHeaderQuery(headerSearchQuery);
      }
    }
  }

  const moveBox = React.useCallback(
    (id: string, left: number, top: number) => {
      setPosition({
        x: left,
        y: top,
      });
      setCanDrag(false);
    },
    [setPosition]
  );

  const [, drop] = useDrop(
    () => ({
      accept: "aimodal",
      drop(item: DragItem, monitor) {
        const delta = monitor.getDifferenceFromInitialOffset() as XYCoord;
        const left = Math.round(item.left + delta.x);
        const top = Math.round(item.top + delta.y);

        moveBox(item.id, left, top);

        return undefined;
      },
    }),
    [moveBox]
  );

  const dragPositionStyle =
    aiModalState !== "full" && (position.x !== 0 || position.y !== 0)
      ? { right: `${-position.x}px`, top: `${position.y}px` }
      : {};

    const examModeContainer = document.getElementById("exam-mode-container");
    const examModeContent = examModeContainer ? examModeContainer.innerHTML : null;
  return (
    <>
      <button
        id="openFarAI"
        className="genericBtn primary"
        onClick={(e) => mainCTA(e)}
      >
        <span className="btnText">{aiContent?.aiName}</span>
      </button>

      {aiModalVisibility ? (
        <>
          <div
            className="dropLocation"
            ref={drop}
            style={{ height: isDragging ? "100%" : 0 }}
          />
          {isDragging ? (
            <div ref={drag} />
          ) : (
            <div
              id="aibox"
              aria-modal="true"
              role="dialog"
              aria-label="Dialogruta AiDa"
              ref={canDrag ? drag : null}
              className={`${
                aiModalState !== "full" ? "draggable" : ""
                  } ${aiModalState} ${aiModalVisibility ? "open" : ""} ${examModeContainer ? "isExamMode" : ""}`}
              data-testid="aibox"
              style={dragPositionStyle}
            >
              <div className="aiMainWrapper">
                <AiMenu
                  setCanDrag={setCanDrag}
                  setAiModalVisibility={setAiModalVisibility}
                />

                {!examModeContainer ? (
                    <div className="ai-modal ai-modal__right-column">
                      <Conversation />
                      <QuestionField />
                    </div>
                ) : (
                    <>
                        <button className="ai-modal-close-x"
                            aria-label="Stäng"
                            onClick={() => {
                                document.dispatchEvent(
                                    new KeyboardEvent("keydown", {
                                        key: "Escape",
                                        code: "Escape",
                                        bubbles: true
                                    })
                                );
                            }}
                        ></button>

                        <div
                            dangerouslySetInnerHTML={{ __html: examModeContent }}
                            />

                        <button className="ai-modal-close"
                            onClick={() => {
                                document.dispatchEvent(
                                    new KeyboardEvent("keydown", {
                                        key: "Escape",
                                        code: "Escape",
                                        bubbles: true
                                    })
                                );
                            }}
                        >
                            OK
                        </button>
                    </>
                )}
              </div>
            </div>
          )}
        </>
      ) : null}
    </>
  );
}
